/*
 * GONE.ARCHIVE (07.09) — domyslna opcja "with chain" na PDP wisiorkow/naszyjnikow.
 * Plik WLASNY: aktualizacja motywu Etheryx go nie nadpisze. Wpiecie: sections/t-product.liquid.
 *
 * Kontekst decyzji (klient, 07.09.2026): w danych produktow "without chain" jest pierwszym
 * wariantem, wiec Shopify renderuje go jako domyslny. Zmiana kolejnosci wariantow w danych
 * dzialalaby od razu na LIVE i zmienialaby cene "od" na kartach — dlatego preselekcja
 * wylacznie w motywie.
 *
 * Mechanizm (ta sama sciezka co ga-variant-picker-mobile.js):
 *   1. Po zaladowaniu strony, gdy URL nie ma parametru ?variant= ALBO parametr wskazuje
 *      PIERWSZY wariant produktu. Karty w kolekcjach linkuja z ?variant=<pierwszy wariant>
 *      (c-prod-card.liquid: cardUrl = current_variant.url), wiec taki parametr to nawigacyjny
 *      domyslny Shopify, nie swiadomy wybor uzytkownika. Jawny link do INNEGO wariantu
 *      (np. udostepniony po recznym wyborze) zachowuje pierwszenstwo. Id pierwszego wariantu
 *      dostarcza JSON #ga-default-chain-data z sections/t-product.liquid.
 *   2. W <variant-selects> szukamy radia o wartosci "with chain" (case-insensitive).
 *   3. Jesli istnieje, nie jest wylaczone i nie jest zaznaczone — zaznaczamy i wysylamy
 *      bubbling 'change'. Dalej dziala ORYGINALNA sciezka motywu: VariantSelects ->
 *      publish(optionValueSelectionChange) -> ProductInfo.renderProductInfo
 *      (cena, media, URL, przycisk Add to cart, synchronizacja mobilnego <select>).
 */
(function () {
  'use strict';

  var TARGET_VALUE = 'with chain';

  function preselect() {
    try {
      var v = new URLSearchParams(window.location.search).get('variant');
      if (v) {
        var data = document.getElementById('ga-default-chain-data');
        var firstId = data ? String((JSON.parse(data.textContent) || {}).firstVariantId || '') : '';
        // ?variant= inny niz pierwszy wariant = swiadomy wybor - nie ruszamy
        if (!firstId || v !== firstId) return;
      }
    } catch (e) {
      return;
    }

    var pickers = document.querySelectorAll('variant-selects');
    for (var p = 0; p < pickers.length; p++) {
      var radios = pickers[p].querySelectorAll('fieldset input[type="radio"]');
      var target = null;
      for (var i = 0; i < radios.length; i++) {
        if ((radios[i].value || '').trim().toLowerCase() === TARGET_VALUE) {
          target = radios[i];
          break;
        }
      }
      if (!target || target.disabled || target.checked) continue;

      target.checked = true;
      target.dispatchEvent(new Event('change', { bubbles: true }));

      // Motyw po zmianie wariantu przenosi fokus na wybrana pigulke (sluszne przy obsludze
      // klawiatura), ale nasza zmiana jest programowa - widoczny ring fokusa bez udzialu
      // uzytkownika wyglada jak blad. Zdejmujemy fokus po re-renderze (kilka prob, bo
      // ProductInfo podmienia DOM asynchronicznie po fetchu). Style fokusa nietkniete.
      [300, 800, 1500].forEach(function (ms) {
        setTimeout(function () {
          var ae = document.activeElement;
          if (ae && ae.matches && ae.matches('.optionValueSelector, variant-selects input, variant-selects label')) {
            ae.blur();
          }
        }, ms);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', preselect);
  } else {
    preselect();
  }
})();
